import { Component, DestroyRef, EventEmitter, Inject, OnInit, Optional, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EffectifByReasonMap } from '@shared/components/effective-needs/interfaces';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { AllFormation } from '@shared/models/allFormation.model';
import { dailyNeeds } from '@shared/models/anesthNeed.model';
import { Formation } from '@shared/models/formation.model';
import { FormationsGroups } from '@shared/models/formationsGroups.model';
import { HospitalTypes } from '@shared/models/hospitalTypes.model';
import { CalendarService } from '@shared/services/calendar.service';
import { InstanceIdService } from '@shared/services/instance-id.service';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import moment from 'moment';
import { posthog } from 'posthog-js';
import { forkJoin, Observable, Subject } from 'rxjs';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { components, frenchDays } from 'src/app/shared/const/globals.const';
import { Profile } from 'src/app/shared/models/profile.model';
import { ReasonMap } from 'src/app/shared/models/reasonMap.model';
import { deactivateComponentService } from 'src/app/shared/services/desactivate.service';
import { ErrorService } from 'src/app/shared/services/error.service';
import { nurseNeedsService } from 'src/app/shared/services/nurseNeeds.service';
import { ParamedicalService } from 'src/app/shared/services/paramedical.service';
import { ReasonMapService } from 'src/app/shared/services/reasonMap.service';
import { RoomService } from 'src/app/shared/services/room.service';
import { UserService } from 'src/app/shared/services/user.service';
import { UtilisService } from 'src/app/shared/services/utilis.service';
import { HrsuiteService } from '../hrsuite.service';

@Component({
  selector: 'app-anesth-needs-garde',
  templateUrl: './anesth-needs-garde.component.html',
  styleUrls: ['./anesth-needs-garde.component.scss'],
  standalone: false,
})
export class anesthNeedsGardeComponent implements OnInit {
  private instanceId: string;

  @Output() public onChange = new EventEmitter<boolean>();

  public osComponentOptions = {
    className: 'os-theme-dark custom-sidebar',
    nativeScrollbarsOverlaid: {
      showNativeScrollbars: true,
    },
    overflowBehavior: {
      x: 'scroll',
      y: 'hidden',
    },
    paddingAbsolute: true,
    scrollbars: {
      autoHide: 'never',
      clickScrolling: true,
    },
  };

  public showDayNight: boolean = false;

  public dayNightOptions = [
    {
      label: 'Jour',
      value: false,
      icon: 'light_mode',
    },
    {
      label: 'Nuit',
      value: true,
      icon: 'dark_mode',
    },
  ];

  public isNight: boolean = true;

  public day: string | undefined;

  private previousDay: string | undefined;

  public thereIsChange: boolean = false;

  public isoDate: string | undefined;

  public targetDate: string | undefined;

  public isLoading: boolean[] = [true, true, true];

  public refreshDateSubject: Subject<void> = new Subject<void>();

  public lastUpdateMessage: string | undefined;

  public days = frenchDays;

  public indexTable = 0;

  public dayNeeds: number[] = new Array(7).fill(0);

  public dayEffectifs: number[] = new Array(7).fill(0);

  public weekDays: string[] = [];

  public daysMap: any = {
    Dimanche: 0,
    Lundi: 1,
    Mardi: 2,
    Mercredi: 3,
    Jeudi: 4,
    Vendredi: 5,
    Samedi: 6,
  };

  public formations: Formation[] = [];

  public selectedNeedsTable: {
    formationsGroup: FormationsGroups;
    display: boolean;
    reasonMapsGarde: ReasonMap[] | undefined;
    gardeNeeds: {
      day: number;
      needs: {
        reasonMap: ReasonMap;
        need: number;
      }[];
      effectifs: {
        reasonMap: ReasonMap;
        effectif: number;
      }[];
      diffs: {
        reasonMap: ReasonMap;
        diff: number;
      }[];
    }[];
  } = { formationsGroup: {}, display: true, reasonMapsGarde: [], gardeNeeds: [] };

  public gardeNeeds: {
    day: number;
    needs: {
      reasonMap: string;
      need: number;
    }[];
    effectifs: {
      reasonMap: ReasonMap;
      effectif: number;
    }[];
    diffs: {
      reasonMap: ReasonMap;
      diff: number;
    }[];
  }[] = [];

  public gardeNeedsTables: {
    formationsGroup: FormationsGroups;
    display: boolean;
    reasonMapsGarde: ReasonMap[] | undefined;
    gardeNeeds: {
      day: number;
      needs: {
        reasonMap: ReasonMap;
        need: number;
      }[];
      effectifs: {
        reasonMap: ReasonMap;
        effectif: number;
      }[];
      diffs: {
        reasonMap: ReasonMap;
        diff: number;
      }[];
    }[];
  }[] = [];

  public selectedFormationDisplayName: string = '';

  private allFormationsGroups: FormationsGroups[] = [];

  private allFormations: AllFormation[] = [];

  public anesthGardeNeedsData: any[] = [];

  public nurseGardeNeedsData: any[] = [];

  public reasonMapsGarde: ReasonMap[] = [];

  private allDays: string[] = [];

  private changedDays: {
    anesthNeeds: Set<number>;
    nurseNeeds: Set<number>;
  } = {
    anesthNeeds: new Set(),
    nurseNeeds: new Set(),
  };

  private effectifByReasonMap: EffectifByReasonMap[] | undefined;

  public get isDataLoading() {
    return this.isLoading.some((loading: any) => loading);
  }

  public accessOption: AccessOptions | undefined;

  public campaignId: string | undefined;

  public scenarioId: string | undefined;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public readonly data: any,
    @Optional() private readonly dialogRef: MatDialogRef<anesthNeedsGardeComponent>,
    private readonly utilisService: UtilisService,
    private readonly hrsuiteService: HrsuiteService,
    private readonly userService: UserService,
    private readonly roomsService: RoomService,
    private readonly nurseNeedsService: nurseNeedsService,
    private readonly errorService: ErrorService,
    private readonly reasonMapService: ReasonMapService,
    private readonly deactivateService: deactivateComponentService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly navigationService: NavigationService,
    private readonly paramedicalService: ParamedicalService,
    private readonly calendarService: CalendarService,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.accessOption = this.userService.getAccessOptionsOfPage(this.router.url);
    const dayAccessOption = this.userService.getAccessOptionsOfPage('/hrsuite/simpledayneeds');
    this.targetDate = sessionStorage.getItem('targetDate') ?? undefined;

    if (dayAccessOption) {
      this.showDayNight = true;
    }
  }

  async ngOnInit() {
    if (this.data?.accessOption) {
      this.accessOption = this.data.accessOption;
    }
    if (this.data?.campaignId) {
      this.campaignId = this.data.campaignId;
    }
    if (this.data?.scenarioId) {
      this.scenarioId = this.data.scenarioId;
    }

    this.initDays();
    this.initStartDate();
    this.day = this.isoDate;
    if (this.targetDate) {
      this.day = this.targetDate;
      this.isoDate = this.targetDate;
    }
    sessionStorage.removeItem('targetDate');

    this.previousDay = this.day;
    this.onSave();
    this.allFormations = await this.userService.getAllFormations();
    this.allFormationsGroups = (await this.userService.getAllFormationsGroups()).filter(
      (formationsGroup: FormationsGroups) =>
        (this.userService.usersHospitals?.[0].hospitalType as HospitalTypes).formationsGroups?.includes(
          formationsGroup._id ?? ''
        ) &&
        formationsGroup.showInBesoinsGarde &&
        this.accessOption?.gardeNeedsTables?.includes(formationsGroup._id ?? '') &&
        (!this.data?.formationsGroups ||
          this.data?.formationsGroups.map((f: any) => String(f._id)).includes(String(formationsGroup._id) ?? ''))
    );
    this.allFormationsGroups.forEach((formationsGroup: FormationsGroups) => {
      if (formationsGroup.formations) {
        formationsGroup.formations = formationsGroup.formations.map((formation: any) => {
          const matchingFormation = this.allFormations.find((formation2: AllFormation) => formation2._id === formation);
          return matchingFormation || formation;
        });
      }
    });
    this.getFormations();
    this.initGardeNeedsTables();
    this.getReasonMapsGarde();
    this.saveAnesthNeedsListener();
    this.refreshAnesthNeedsListener();

    if (this.indexTable !== undefined && this.gardeNeedsTables.length > 0) {
      this.selectedNeedsTable = this.gardeNeedsTables[this.indexTable];
    }
    for (let i = 0; i < 7; i++) {
      this.weekDays.push(this.calculateWeekDays(i));
      this.computeDayNeeds(i, -1);
    }
  }

  initStartDate() {
    if (this.data?.date) {
      this.isoDate = moment.utc(this.data.date).toISOString();
    } else {
      const date = new Date(this.utilisService.getDate(components.ANE_NEEDS_COMPONENT)!.format('YYYY-MM-DD'));
      this.isoDate = moment.utc(date).startOf('week').toISOString();
    }
  }

  initDays() {
    if (this.data?.dayOfTheWeek) {
      this.days = [this.data.dayOfTheWeek];
    }
  }

  initGardeNeedsTables() {
    this.gardeNeedsTables = [];
    this.selectedFormationDisplayName = this.allFormationsGroups[0]?.displayName || '';

    this.allFormationsGroups.forEach((formationsGroup: FormationsGroups) => {
      const gardeNeedsTableData: {
        formationsGroup: FormationsGroups;
        display: boolean;
        reasonMapsGarde: ReasonMap[] | undefined;
        gardeNeeds: {
          day: number;
          needs: {
            reasonMap: ReasonMap;
            need: number;
          }[];
          effectifs: {
            reasonMap: ReasonMap;
            effectif: number;
          }[];
          diffs: {
            reasonMap: ReasonMap;
            diff: number;
          }[];
        }[];
      } = {
        formationsGroup,
        display: true,
        reasonMapsGarde: undefined,
        gardeNeeds: [],
      };

      this.days.forEach((currentDay: string) => {
        gardeNeedsTableData.gardeNeeds.push({
          day: frenchDays.findIndex((frenchDay: string) => currentDay === frenchDay) + 1,
          needs: [],
          effectifs: [],
          diffs: [],
        });
      });

      this.gardeNeedsTables.push(gardeNeedsTableData);
    });
    this.indexTable = this.gardeNeedsTables?.findIndex(
      (needTable: any) => needTable.formationsGroup.displayName === this.selectedFormationDisplayName
    );
    if (this.indexTable !== undefined) {
      this.selectedNeedsTable = this.gardeNeedsTables[this.indexTable];
    } else {
      this.selectedNeedsTable = { formationsGroup: {}, display: true, reasonMapsGarde: [], gardeNeeds: [] };
    }
    for (let i = 0; i < 7; i++) {
      this.computeDayNeeds(i, -1);
    }
  }

  getFormations() {
    this.subscriptionManager
      .createRequest(this.paramedicalService.getFormations(), 'getFormations', this.instanceId)
      .subscribe({
        next: (res: Formation[]) => {
          this.formations = res;
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async toggleNight() {
    this.navigationService.navigateTo('/hrsuite/simpledayneeds');
  }

  updateDiff(event: number | null, index: number, i: number) {
    if (Number.isInteger(this.selectedNeedsTable?.gardeNeeds?.[i]?.effectifs?.[index]?.effectif)) {
      this.selectedNeedsTable.gardeNeeds[i].diffs[index].diff =
        this.selectedNeedsTable?.gardeNeeds?.[i]?.effectifs?.[index]?.effectif - (event ?? 0);
    }
  }

  blockInvalidInput(event: KeyboardEvent, value: number, dayIndex: number): void {
    const invalidChars = ['e', 'E', '+', '-', '.', ',', ';'];
    const isNumber = /^[0-9]$/.test(event.key);

    if (invalidChars.includes(event.key) || ((event.key === 'ArrowUp' || isNumber) && value >= 999)) {
      event.preventDefault();
    } else if (
      isNumber ||
      event.key === 'Enter' ||
      event.key === 'Backspace' ||
      event.key === 'ArrowUp' ||
      event.key === 'ArrowDown'
    ) {
      this.change(dayIndex);
    }
  }

  setDefaultIfEmpty(currentValue: any, index: number, i: number) {
    if (currentValue === null || currentValue === undefined || currentValue === '') {
      this.selectedNeedsTable.gardeNeeds[i].needs[index].need = 0;
      this.computeDayNeeds(i, index, 0);
      this.change(i);
    }
  }

  computeDayNeeds(dayIndex: number, reasonMapIndex: number, value?: number) {
    let needsCount = 0;
    this.selectedNeedsTable?.gardeNeeds[dayIndex]?.needs.forEach((reasonMapNeed: any, index: number) => {
      if (index === reasonMapIndex && value !== undefined) {
        needsCount += value;
      } else {
        needsCount += Number(reasonMapNeed.need) || 0;
      }
    });
    this.dayNeeds[dayIndex] = needsCount;
  }

  preventPaste(event: any) {
    event.preventDefault();
  }

  saveAnesthNeedsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.saveAnesthNeedsSubject, 'saveAnesthNeedsSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.save();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  refreshAnesthNeedsListener() {
    this.subscriptionManager
      .createRequest(this.hrsuiteService.refreshAnesthNeedsSubject, 'refreshAnesthNeedsSubject', this.instanceId)
      .subscribe({
        next: () => {
          this.refresh();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  clearChangedDays(): void {
    this.changedDays.anesthNeeds.clear();
    this.changedDays.nurseNeeds.clear();
  }

  refresh(): void {
    this.isLoading = [true, true, true];
    this.gardeNeedsTables = [];
    this.dayNeeds = [];
    this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
    this.thereIsChange = false;
    this.onChange.emit(false);
    this.clearChangedDays();
    this.initGardeNeedsTables();
    this.getEffectiveNeeds();
  }

  onSave() {
    this.subscriptionManager
      .createRequest(this.deactivateService.switchDeactivate, 'switchDeactivate', this.instanceId)
      .subscribe({
        next: (toSave: any) => {
          if (toSave) {
            this.save();
          }
        },
        error: (error: any) => this.errorService.handleError(error),
      });
  }

  isChangesUnsaved() {
    return this.thereIsChange;
  }

  getReasonMapsGarde() {
    this.isLoading = [true, true, true];

    this.subscriptionManager
      .createRequest(this.reasonMapService.getNightReasonsMaps(), 'getNightReasonsMaps', this.instanceId)
      .subscribe({
        next: (res: any) => {
          if (Array.isArray(res?.[0]?.reasonsmaps)) {
            this.reasonMapsGarde = res[0].reasonsmaps.filter((reasonMap: ReasonMap) => !reasonMap.fromAdjustmentAlgo);

            if (this.accessOption?.seniority?.length === 1 && this.accessOption?.seniority[0] === 'Interne') {
              this.reasonMapsGarde = this.reasonMapsGarde.filter(
                (reasonMap: ReasonMap) =>
                  reasonMap.reason &&
                  typeof reasonMap.reason === 'object' &&
                  reasonMap.reason.seniority &&
                  reasonMap.reason.seniority.includes('Interne')
              );
            }
          }
          this.getEffectiveNeeds();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  getEffectiveNeeds() {
    const date = moment(this.isoDate).clone().utc().format('YYYY-MM-DD');
    const startTime = new Date(this.day!);
    const endTime = new Date(this.day!);
    endTime.setDate(endTime.getDate() + 6);

    this.subscriptionManager
      .createRequest(
        forkJoin({
          nightGardeNeeds: this.roomsService.getAnesthDailyNeeds(date, 'NIGHT'),
          nurseNeeds: this.nurseNeedsService.getNurseDailyNeeds(date, 'NIGHT'),
        }),
        'getEffectiveNeeds',
        this.instanceId
      )
      .subscribe({
        next: async ({ nightGardeNeeds, nurseNeeds }: { nightGardeNeeds: dailyNeeds[]; nurseNeeds: any[] }) => {
          if (['anesth', 'iade'].includes(this.selectedNeedsTable?.formationsGroup?.typeMode as string)) {
            await this.setLastUpdateMessage(nightGardeNeeds);
          } else {
            await this.setLastUpdateMessage(nurseNeeds);
          }
          this.anesthGardeNeedsData = nightGardeNeeds;
          this.nurseGardeNeedsData = nurseNeeds;
          this.initAnesthGardeNeeds();
          this.initNurseNeeds();

          const allFormationsFromGardeNeeds = this.getAllFormationsFromGardeNeeds();
          this.subscriptionManager
            .createRequest(
              this.calendarService.countEffectifByReasonMap(
                startTime.toISOString(),
                endTime.toISOString(),
                allFormationsFromGardeNeeds.map((formation: Formation) => formation.name) as string[],
                'NIGHT',
                this.scenarioId,
                this.campaignId
              ),
              'countEffectifByReasonMap',
              this.instanceId
            )
            .subscribe({
              next: (result: EffectifByReasonMap[]) => {
                this.effectifByReasonMap = result;
                this.computeEffectifs();
                this.isLoading[2] = false;
              },
              error: (error: any) => {
                this.errorService.handleError(error);
              },
            });
        },
        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  private extractFormations(gardeNeedsTable: any): AllFormation[] {
    const validFormations = gardeNeedsTable.formationsGroup.formations;
    if (Array.isArray(validFormations) && validFormations.length > 0) {
      return validFormations as AllFormation[];
    }
    return [];
  }

  private getAllFormationsFromGardeNeeds(): AllFormation[] {
    return this.gardeNeedsTables.reduce(
      (allFormations: AllFormation[], gardeNeedsTable: any) => [
        ...allFormations,
        ...this.extractFormations(gardeNeedsTable),
      ],
      []
    );
  }

  computeEffectifs(): void {
    for (const gardeNeedsTable of this.gardeNeedsTables) {
      const positions = gardeNeedsTable.formationsGroup?.formations?.map((elt: Formation) => elt.name ?? '') ?? [];
      gardeNeedsTable.gardeNeeds.forEach((gardeNeed: any, index: number) => {
        this.resetGardeNeed(gardeNeed);

        if (this.hasReasonMaps(gardeNeedsTable)) {
          gardeNeedsTable.reasonMapsGarde!.forEach((reasonMapGarde: any) => {
            this.initializeGardeNeedEffectifs(gardeNeed, reasonMapGarde);

            const effectifs = this.getEffectifsByReasonAndDate(reasonMapGarde._id, this.allDays[index], positions);
            const totalEffectif = this.calculateTotalEffectif(effectifs, this.allDays[index], positions);
            this.updateLastEffectif(gardeNeed, totalEffectif);
          });
        }
      });
    }
    this.computeDiffs();
    this.computeDayEffectifs();
  }

  computeDayEffectifs(): void {
    const gardeNeeds = this.selectedNeedsTable?.gardeNeeds ?? [];

    if (!Array.isArray(gardeNeeds) || gardeNeeds.length === 0) {
      return;
    }

    gardeNeeds.forEach((need: any, index: number) => {
      this.dayEffectifs[index] = this.calculateTotalEffectifsForDay(need?.effectifs ?? []);
    });
  }

  private calculateTotalEffectifsForDay(gardeNeeds: any[]): number {
    return gardeNeeds.reduce(
      (total: number, eff: { reasonMap: ReasonMap; effectif: number }) => total + (eff?.effectif || 0),
      0
    );
  }

  private resetGardeNeed(gardeNeed: any): void {
    gardeNeed.effectifs = [];
    gardeNeed.diffs = [];
  }

  private hasReasonMaps(gardeNeedsTable: any): boolean {
    return Array.isArray(gardeNeedsTable?.reasonMapsGarde) && gardeNeedsTable.reasonMapsGarde.length > 0;
  }

  private initializeGardeNeedEffectifs(gardeNeed: any, reasonMapGarde: any): void {
    gardeNeed.effectifs.push({ reasonMap: reasonMapGarde, effectif: 0 });
    gardeNeed.diffs.push({ reasonMap: reasonMapGarde, diff: 0 });
  }

  private getEffectifsByReasonAndDate(reasonMapId: string, targetDate: string, positions: string[]): any[] {
    return (
      this.effectifByReasonMap
        ?.find((eff: EffectifByReasonMap) => String(eff.reasonMapId) === String(reasonMapId))
        ?.effectif?.filter(
          (eff: any) =>
            positions.includes(eff.position) && eff?.byDates.some((byDate: any) => byDate.date === targetDate)
        ) || []
    );
  }

  private calculateTotalEffectif(effectifs: any[], targetDate: string, positions: string[]): number {
    return effectifs.reduce((total: number, eff: any) => {
      const byDate = positions.includes(eff.position) && eff.byDates.find((byDate: any) => byDate.date === targetDate);
      return total + (byDate?.count || 0);
    }, 0);
  }

  private updateLastEffectif(gardeNeed: any, totalEffectif: number): void {
    const lastEffectif = gardeNeed.effectifs.at(-1);
    if (lastEffectif) {
      lastEffectif.effectif = totalEffectif;
    }
  }

  computeDiffs(): void {
    if (!this.isNonEmptyArray(this.gardeNeedsTables)) {
      return;
    }

    for (const table of this.gardeNeedsTables) {
      if (!this.isNonEmptyArray(table.gardeNeeds)) {
        continue;
      }

      for (const need of table.gardeNeeds) {
        this.computeNeedDiffs(need);
      }
    }
  }

  private isNonEmptyArray(array: any[]): boolean {
    return Array.isArray(array) && array.length > 0;
  }

  private computeNeedDiffs(gardeNeed: any): void {
    const length = gardeNeed.needs.length;

    for (let i = 0; i < length; i++) {
      const need = gardeNeed.needs[i]?.need ?? 0;
      const effectif = gardeNeed.effectifs[i]?.effectif ?? 0;
      gardeNeed.diffs[i].diff = effectif - need;
    }
  }

  initAnesthGardeNeeds() {
    this.gardeNeedsTables.forEach((gardeNeedsTable: any) => {
      if (
        gardeNeedsTable.formationsGroup.typeMode === 'anesth' ||
        gardeNeedsTable.formationsGroup.typeMode === 'iade'
      ) {
        const formations_group = gardeNeedsTable.formationsGroup.formations.map((elt: Formation) => elt.name);
        const formations_names = this.formations
          .filter((elt: Formation) => formations_group.includes(elt.name))
          .map((elt: Formation) => elt.name);
        const reasonMapsGardeFormationsGroup = this.reasonMapsGarde.filter((ReasonMapGarde: ReasonMap) =>
          formations_names.some((formation: any) => ReasonMapGarde.positions?.includes(formation))
        );
        gardeNeedsTable.reasonMapsGarde = reasonMapsGardeFormationsGroup;
        gardeNeedsTable.gardeNeeds.forEach((gardeNeed: any, index: number) => {
          const fixNeedData = this.anesthGardeNeedsData.find(
            (n: any) => (new Date(n.date).getDay() === 0 ? 7 : new Date(n.date).getDay()) === index + 1
          );

          reasonMapsGardeFormationsGroup.forEach((reasonMapGarde: any) => {
            const fixNeedDataReasonMap = fixNeedData
              ? fixNeedData.needs.find(
                  (need: any) =>
                    String(need.reasonMap) === String(reasonMapGarde._id) &&
                    String(need.formationsGroup) === String(gardeNeedsTable.formationsGroup._id)
                )
              : null;
            gardeNeed.needs.push({
              reasonMap: reasonMapGarde,
              need: fixNeedDataReasonMap ? fixNeedDataReasonMap.need : 0,
            });
          });
        });
      }
    });
    this.indexTable = this.gardeNeedsTables?.findIndex(
      (needTable: any) => needTable.formationsGroup.displayName === this.selectedFormationDisplayName
    );
    if (this.indexTable !== undefined) {
      this.selectedNeedsTable = this.gardeNeedsTables[this.indexTable];
    } else {
      this.selectedNeedsTable = { formationsGroup: {}, display: true, reasonMapsGarde: [], gardeNeeds: [] };
    }
    for (let i = 0; i < 7; i++) {
      this.computeDayNeeds(i, -1);
    }
    this.isLoading[0] = false;
  }

  async setLastUpdateMessage(data: any[]): Promise<void> {
    let lastUpdateDate: string | undefined;
    let lastUpdateUser: Profile | undefined;
    let updatedNeeds: any[] = [];

    if (typeof data === 'object' && Object.keys(data).length === 0 && this.day === this.previousDay) {
      lastUpdateUser = this.storageService.getUser().profile!;
    } else if (Object.keys(data).length > 0) {
      data.map((e: any) => (e.modified ? updatedNeeds.push(e) : null));
      if (updatedNeeds.length === 0) {
        updatedNeeds = data;
        lastUpdateUser = this.storageService.getUser().profile!;
      }

      let mostRecentDate: Date | null = null;
      updatedNeeds.forEach((e: any) => {
        if (e.updatedBy && typeof e.updatedBy === 'object') {
          const currentUpdatedAt = new Date(e.updatedAt);
          if (!mostRecentDate || currentUpdatedAt > mostRecentDate) {
            mostRecentDate = currentUpdatedAt;
            lastUpdateDate = e.updatedAt;
            if (!lastUpdateUser) {
              lastUpdateUser = e.updatedBy;
            }
          }
        }
      });
    }
    const arr = moment(lastUpdateDate).format('YYYY-MM-DD').split('-');
    const updateDate = arr[2] + '/' + arr[1] + '/' + arr[0];
    const updateHour = moment(lastUpdateDate).format('HH:mm');
    const doesAccessOptionsHaveNurses = await this.userService.doesAccessOptionHaveNurses(this.accessOption);
    const doesAccessOptionsHaveIades = await this.userService.doesAccessOptionHaveIades(this.accessOption);
    const doesAccessOptionsHaveAnesthesistes = await this.userService.doesAccessOptionHaveAnesthesistes(
      this.accessOption
    );

    if (
      lastUpdateUser &&
      (lastUpdateUser.position == this.userService.getCurrentUser().profile?.position ||
        (doesAccessOptionsHaveNurses && doesAccessOptionsHaveIades && doesAccessOptionsHaveAnesthesistes))
    ) {
      this.lastUpdateMessage = `Modifié le ${updateDate} à ${updateHour}\npar ${lastUpdateUser.firstName} ${lastUpdateUser.lastName}\n`;
    } else {
      this.lastUpdateMessage = '';
    }
  }

  initNurseNeeds() {
    this.gardeNeedsTables.forEach((gardeNeedsTable: any) => {
      if (gardeNeedsTable.formationsGroup.typeMode === 'nurse') {
        const formations_group = gardeNeedsTable.formationsGroup.formations.map((elt: Formation) => elt.name);
        const formations_names = this.formations
          .filter((elt: Formation) => formations_group.includes(elt.name))
          .map((elt: Formation) => elt.name);
        const reasonMapsGardeFormationsGroup = this.reasonMapsGarde.filter((ReasonMapGarde: ReasonMap) =>
          formations_names.some((formation: any) => ReasonMapGarde.positions?.includes(formation))
        );
        gardeNeedsTable.reasonMapsGarde = reasonMapsGardeFormationsGroup;
        gardeNeedsTable.gardeNeeds.forEach((gardeNeed: any) => {
          const fixNeedData = this.nurseGardeNeedsData.find(
            (n: any) => (new Date(n.date).getDay() === 0 ? 7 : new Date(n.date).getDay()) === gardeNeed.day
          );
          reasonMapsGardeFormationsGroup.forEach((reasonMapGarde: any) => {
            const fixNeedDataReasonMap = fixNeedData
              ? fixNeedData.needs.find(
                  (need: any) =>
                    String(need.reasonMap) === String(reasonMapGarde._id) &&
                    String(need.formationsGroup) === String(gardeNeedsTable.formationsGroup._id)
                )
              : null;
            gardeNeed.needs.push({
              reasonMap: reasonMapGarde,
              need: fixNeedDataReasonMap ? fixNeedDataReasonMap.need : 0,
            });
          });
        });
      }
    });
    this.indexTable = this.gardeNeedsTables?.findIndex(
      (needTable: any) => needTable.formationsGroup.displayName === this.selectedFormationDisplayName
    );
    if (this.indexTable !== undefined) {
      this.selectedNeedsTable = this.gardeNeedsTables[this.indexTable];
    } else {
      this.selectedNeedsTable = { formationsGroup: {}, display: true, reasonMapsGarde: [], gardeNeeds: [] };
    }
    for (let i = 0; i < 7; i++) {
      this.computeDayNeeds(i, -1);
    }

    this.isLoading[1] = false;
  }

  change(dayIndex: number) {
    this.thereIsChange = true;
    this.hrsuiteService.isChangeAnesthNeedsSubject.next(true);
    this.onChange.emit(true);
    if (!dayIndex && dayIndex !== 0) {
      return;
    }

    //Increment by 1 to put the actual day number instead of day Index that starts with 0
    dayIndex++;

    switch (this.selectedNeedsTable.formationsGroup.typeMode) {
      case 'anesth':
        this.changedDays.anesthNeeds.add(dayIndex);
        break;
      case 'iade':
        this.changedDays.anesthNeeds.add(dayIndex);
        break;
      case 'nurse':
        this.changedDays.nurseNeeds.add(dayIndex);
        break;
    }
  }

  onChangeSelectedNeedsTable(event: any) {
    posthog.capture('Switch_Formation_Group', { page_source: 'Needs_Garde' });
    this.selectedNeedsTable = event;
    this.selectedFormationDisplayName = event.formationsGroup.displayName;
    this.indexTable = this.gardeNeedsTables?.findIndex(
      (needTable: any) => needTable.formationsGroup.displayName === this.selectedFormationDisplayName
    );
    if (this.indexTable !== undefined) {
      this.selectedNeedsTable = this.gardeNeedsTables[this.indexTable];
    } else {
      this.selectedNeedsTable = { formationsGroup: {}, display: true, reasonMapsGarde: [], gardeNeeds: [] };
    }
    this.selectedNeedsTable.display = true;
    for (let i = 0; i < 7; i++) {
      this.computeDayNeeds(i, -1);
    }
  }

  increaseNeeds(i: number, index: number, needs: any[]): any {
    const maxValue = 999;
    const currentValue = needs[i].needs[index].need;

    if (currentValue < maxValue) {
      this.change(i);
      this.dayNeeds[i] += 1;
      if (Number.isInteger(this.selectedNeedsTable?.gardeNeeds?.[i]?.diffs?.[index]?.diff)) {
        this.selectedNeedsTable.gardeNeeds[i].diffs[index].diff--;
      }
      return currentValue + 1;
    }
    return currentValue;
  }

  decreaseNeeds(i: number, index: number, needs: any[]): any {
    const minValue = 0;
    const currentValue = needs[i].needs[index].need;

    if (currentValue > minValue) {
      this.change(i);
      this.dayNeeds[i] -= 1;
      if (Number.isInteger(this.selectedNeedsTable?.gardeNeeds?.[i]?.diffs?.[index]?.diff)) {
        this.selectedNeedsTable.gardeNeeds[i].diffs[index].diff++;
      }
      return currentValue - 1;
    }
    return currentValue;
  }

  validateNeed(value: number, i: number, index: number, reasonMapIndex: number) {
    const min = 0;
    const max = 999;
    const clampedValue = Math.min(Math.max(value, min), max);

    this.selectedNeedsTable.gardeNeeds[i].needs[index] = {
      ...this.selectedNeedsTable.gardeNeeds[i].needs[index],
      need: clampedValue,
    };

    this.computeDayNeeds(i, reasonMapIndex, clampedValue);
  }

  isDayDisabled(day: string, reasonMapGarde: any): boolean {
    if (reasonMapGarde.days && reasonMapGarde.days.length > 0) {
      const day_index = this.daysMap[day];
      return !reasonMapGarde.days.includes(day_index);
    }
    return true;
  }

  getLastMonday(date: Date) {
    const dayOfWeek = date.getUTCDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const lastMonday = new Date(date);
    lastMonday.setUTCDate(date.getUTCDate() - daysToSubtract);
    return lastMonday;
  }

  chosenDayHandler(event: any) {
    const previousSelectedNeedsTable = this.selectedNeedsTable;
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent2', this.instanceId).subscribe({
      next: (res: any) => {
        if (res !== 'cancel' && !res) {
          this.day = this.isoDate;
          this.save();
        }
        if (res !== 'cancel') {
          const newDate: Date = new Date(Date.UTC(event.value._i.year, event.value._i.month, event.value._i.date));
          const previousMonday = this.getLastMonday(newDate);
          this.day = previousMonday.toISOString();
          this.isoDate = previousMonday.toISOString();
          this.isLoading = [true, true, true];
          this.initGardeNeedsTables();
          this.getEffectiveNeeds();
          this.thereIsChange = false;
          this.onChange.emit(false);
          this.clearChangedDays();
          this.weekDays = [];
          this.allDays = [];
          for (let i = 0; i < 7; i++) {
            this.weekDays.push(this.calculateWeekDays(i));
          }
        } else if (res === 'cancel') {
          this.refreshDateSubject.next();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
    this.onChangeSelectedNeedsTable(previousSelectedNeedsTable);
  }

  onWeekChange(type: string) {
    const previousSelectedNeedsTable = this.selectedNeedsTable;
    this.subscriptionManager.createRequest(this.goToNextEvent(), 'goToNextEvent', this.instanceId).subscribe({
      next: (res: any) => {
        if (res === true) {
          let dateCopy = new Date(this.isoDate!);
          switch (type) {
            case 'previous':
              dateCopy = new Date(dateCopy.getTime() - 7 * 24 * 60 * 60 * 1000);
              break;
            case 'next':
              dateCopy = new Date(dateCopy.getTime() + 7 * 24 * 60 * 60 * 1000);
              break;
          }
          this.day = dateCopy.toISOString();
          this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
          this.onChange.emit(false);
          this.clearChangedDays();
          this.isoDate = dateCopy.toISOString();
          this.isLoading = [true, true, true];
          this.initGardeNeedsTables();
          this.getEffectiveNeeds();
          this.thereIsChange = false;
          this.weekDays = [];
          this.allDays = [];
          for (let i = 0; i < 7; i++) {
            this.weekDays.push(this.calculateWeekDays(i));
          }
        } else if (res !== 'cancel') {
          this.day = this.isoDate;
          this.save();
        }
      },

      error: (error: any) => {
        this.errorService.handleError(error);
      },
    });
    this.onChangeSelectedNeedsTable(previousSelectedNeedsTable);
  }

  calculateWeekDays(index: any) {
    const date = new Date(this.day!);
    date.setDate(date.getDate() + index);

    this.allDays.push(moment(date).locale('fr').format('YYYY-MM-DD'));

    return moment(date).locale('fr').format('DD MMM');
  }

  goToNextEvent() {
    if (this.thereIsChange) {
      return this.utilisService.openUnSavedChangesPopup();
    } else {
      return new Observable((sub: any) => sub.next(true));
    }
  }

  save(): Promise<void> {
    return new Promise(async (resolve: any, reject: any) => {
      try {
        this.hrsuiteService.isSavingAnesthNeeds = true;

        const anesthData: any[] = [];
        const nurseData: any[] = [];

        const hospital = this.userService.getSelectedHospitals()[0];

        for (const gardeNeedTable of this.gardeNeedsTables) {
          gardeNeedTable.gardeNeeds.forEach((gardeNeed: any) => {
            const dataAnesth = anesthData.find((d: any) => d.day === gardeNeed.day);
            const dataNurse = nurseData.find((d: any) => d.day === gardeNeed.day);

            if (
              gardeNeedTable.formationsGroup.typeMode === 'anesth' ||
              gardeNeedTable.formationsGroup.typeMode === 'iade'
            ) {
              if (!this.changedDays.anesthNeeds.has(gardeNeed.day)) {
                return;
              }
              if (dataAnesth) {
                dataAnesth.needs = dataAnesth.needs.concat(
                  gardeNeed.needs.map((needData: any) => ({
                    need: needData.need,
                    reasonMap: { _id: needData.reasonMap._id },
                    formationsGroup: gardeNeedTable.formationsGroup._id,
                  }))
                );
              } else {
                anesthData.push({
                  hospital,
                  needs: gardeNeed.needs.map((needData: any) => ({
                    need: needData.need,
                    reasonMap: { _id: needData.reasonMap._id },
                    formationsGroup: gardeNeedTable.formationsGroup._id,
                  })),
                  day: gardeNeed.day,
                  period: 'NIGHT',
                });
              }
            } else {
              if (!this.changedDays.nurseNeeds.has(gardeNeed.day)) {
                return;
              }
              if (dataNurse) {
                dataNurse.needs = dataNurse.needs.concat(
                  gardeNeed.needs.map((needData: any) => ({
                    need: needData.need,
                    reasonMap: { _id: needData.reasonMap._id },
                    formationsGroup: gardeNeedTable.formationsGroup._id,
                  }))
                );
              } else {
                nurseData.push({
                  hospital,
                  needs: gardeNeed.needs.map((needData: any) => ({
                    need: needData.need,
                    reasonMap: { _id: needData.reasonMap._id },
                    formationsGroup: gardeNeedTable.formationsGroup._id,
                  })),
                  day: gardeNeed.day,
                  period: 'NIGHT',
                });
              }
            }
          });
        }
        const date = moment(this.isoDate).clone().utc().format('YYYY-MM-DD');

        // Create observables array for requests that need to be executed
        const requests: Observable<any>[] = [];

        if (anesthData.length > 0) {
          requests.push(this.roomsService.updateAnesthDailyNeeds(date, anesthData));
        }

        // Only add requests if there are actual changes
        if (nurseData.length > 0) {
          requests.push(this.nurseNeedsService.updateNurseDailyNeeds(date, nurseData));
        }

        // If no data to save, resolve immediately
        if (requests.length === 0) {
          this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
          this.hrsuiteService.isSavingAnesthNeeds = false;
          this.thereIsChange = false;
          this.onChange.emit(false);
          this.clearChangedDays();
          this.utilisService.displaySuccessToast();
          resolve();
          return;
        }

        // Execute all requests in parallel using forkJoin
        this.subscriptionManager.createRequest(forkJoin(requests), 'updateDailyNeeds', this.instanceId).subscribe({
          next: (results: any[]) => {
            // Get the last result for setLastUpdateMessage (nurse data if available, otherwise anesth data)
            const dataR = nurseData.length > 0 ? results[requests.length - 1] : results[0];

            // Update the original data with the new saved values for future change detection
            this.updateOriginalDataAfterSave(anesthData, nurseData);

            this.hrsuiteService.isChangeAnesthNeedsSubject.next(false);
            this.hrsuiteService.isSavingAnesthNeeds = false;
            this.setLastUpdateMessage(dataR);
            this.thereIsChange = false;
            this.onChange.emit(false);
            this.clearChangedDays();
            this.utilisService.displaySuccessToast();
            resolve();
          },
          error: (error: any) => {
            this.hrsuiteService.isSavingAnesthNeeds = true;
            this.errorService.handleError(error);
            reject(error);
          },
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * Updates the original data arrays with the saved values to ensure proper change detection on subsequent saves
   */
  private updateOriginalDataAfterSave(anesthData: any[], nurseData: any[]): void {
    // Update anesthesia garde needs data
    if (anesthData.length > 0) {
      anesthData.forEach((dayData: any) => {
        const originalDay = this.anesthGardeNeedsData.find(
          (n: any) => (new Date(n.date).getDay() === 0 ? 7 : new Date(n.date).getDay()) === dayData.day
        );

        if (originalDay) {
          dayData.needs.forEach((need: any) => {
            const originalNeed = originalDay.needs.find(
              (originalNeed: any) =>
                String(originalNeed.reasonMap) === String(need.reasonMap._id) &&
                String(originalNeed.formationsGroup) === String(need.formationsGroup)
            );

            if (originalNeed) {
              originalNeed.need = need.need;
            } else {
              // Add new need if it doesn't exist
              originalDay.needs.push({
                need: need.need,
                reasonMap: need.reasonMap._id,
                formationsGroup: need.formationsGroup,
              });
            }
          });
        }
      });
    }

    // Update nurse garde needs data
    if (nurseData.length > 0) {
      nurseData.forEach((dayData: any) => {
        const originalDay = this.nurseGardeNeedsData.find(
          (n: any) => (new Date(n.date).getDay() === 0 ? 7 : new Date(n.date).getDay()) === dayData.day
        );

        if (originalDay) {
          dayData.needs.forEach((need: any) => {
            const originalNeed = originalDay.needs.find(
              (originalNeed: any) =>
                String(originalNeed.reasonMap) === String(need.reasonMap._id) &&
                String(originalNeed.formationsGroup) === String(need.formationsGroup)
            );

            if (originalNeed) {
              originalNeed.need = need.need;
            } else {
              // Add new need if it doesn't exist
              originalDay.needs.push({
                need: need.need,
                reasonMap: need.reasonMap._id,
                formationsGroup: need.formationsGroup,
              });
            }
          });
        }
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
